import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import ProgressModal from "../../components/modals/ProgressModal";

export function TraceabilityViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(null);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const showProgressModal = (message = "Processing...") => {
    setEmptyModelOpen({
      childComponent: <ProgressModal message={message} />,
      open: true,
    });
  };

  const onTraceBarcode = async function ($scannedBarcode, reportType) {
    setLoading(true);
    setProduct(null);
    let callResult = await makePostApiCall(`traceBarcode/${$scannedBarcode}`, {
      reportType: reportType.value,
    });
    if (callResult.success) {
      setProduct(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const printPackagingMaterialTraceReport = async function ($scannedBarcode) {
    showProgressModal("Preparing report...");
    let callResult = await makePostApiCall(
      `printPackagingMaterialTraceabilityReport/${$scannedBarcode}`,
      {}
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setEmptyModelOpen({
      childComponent: null,
      open: false,
    });
  };

  const printManufacturedProductTraceReport = async function ($scannedBarcode) {
    showProgressModal("Preparing report...");
    let callResult = await makePostApiCall(
      `printManufacturedProductTraceabilityReport/${$scannedBarcode}`,
      {}
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setEmptyModelOpen({
      childComponent: null,
      open: false,
    });
  };

  const printSupplierItemTraceReport = async function ($scannedBarcode) {
    showProgressModal("Preparing report...");
    let callResult = await makePostApiCall(
      `printSupplierItemTraceabilityReport/${$scannedBarcode}`,
      {}
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setEmptyModelOpen({
      childComponent: null,
      open: false,
    });
  };

  return {
    loading,
    product,
    setProduct,
    slideOver,
    setSlideOver,
    onTraceBarcode,
    emptyModal,
    setEmptyModelOpen,
    printPackagingMaterialTraceReport,
    printManufacturedProductTraceReport,
    printSupplierItemTraceReport,
  };
}
